import styled, { createGlobalStyle } from "styled-components";
import bgImg from "../assets/bg-icons.png";
import bgImgPublic from "../assets/senai-fundo.jpg";

export const Container = styled.div`
  width: 100vw;
  flex: 1;

  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ContainerPublic = styled.div`
  width: 100vw;
  flex: 1;

  background-image: url(${bgImgPublic});
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;

  ::after {
    content: "";
    position: absolute;
    width: 100vw;
    height: 100%;
    top: 0;

    background-color: #ccc9;

    z-index: 1;
  }

  + div {
    position: absolute;
    bottom: 0;
  }
`;

export const GlobalStyle = createGlobalStyle`

  :root {
    --primary:  #de1d13;
    --white: #EEEEEE;
    --gray: #3A3A3A;
    --bgContent: #EEE;
    --green: #00AA00;
    --darkGreen: #006400;
    --blue: #0000AA;
    --overlay: #00000099;
    --overlayLight: #00000033;
    --whiteTransparent: #FFFC;
    --black: #111;
    --alertErro: #AA0000EE;
    --alertSucesso: #00AA00DD;
    --gradientPrimary: #d8324a;
    --gradientSecondary: #811a29;
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;

    box-sizing: border-box;
  }

  body {
    font-family: Montserrat;

    background-color: #DDD;

    overflow-x: hidden;

     background-image: url(${bgImg});
  background-position: top;
  background-size: 600px;
  }

  ::-webkit-scrollbar-track {
    background-color: var(--white);
  }
  ::-webkit-scrollbar {
    width: 4px;
    background: var(--primary);
  }
  ::-webkit-scrollbar-thumb {
    background:  var(--primary);
  }

  input, select, textarea {
    
    color: var(--black);
    background-color: #0000;
    font-size: 16px;
    border: 0px;
    border-bottom: 1px solid black;

    font-family: Montserrat;

    font-weight: bold;
    height: 30px;

    transition: 0.2s;

    resize: none;
  }

  textarea {
    height: 100px;
  }


  
  button {
    padding: 10px;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 18px;

    border-radius: 10px;
    
    color: var(--white);
    background-color: var(--primary);
    border: 1px solid var(--white);

    transition: 0.2s;

    cursor: pointer;

    :active {
      border: 1px solid var(--gray);
      transform: scale(0.95);
    }

    :hover {
      opacity: 0.8;
    }

    :disabled{
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  a[id="link-termo"]{
    color: var(--primary);
    :visited{
      color: var(--primary);
    }
  }
`;
